// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonErrorApiCodeUnaffiliated = {
  ctfAuthDataContractInvalid: "CTF の現在のユーザーロール契約が無効です。管理者に連絡してください",
  eduAuthDataContractInvalid: "EDU の現在のユーザーロール契約が無効です。管理者に連絡してください",
  eduAuthMemberAccessRequired: "このアカウントには EDU ポータル利用権限がまだありません",
  eduDependencyDatabaseUnavailable:
    "データベースは一時的に利用できません。しばらくしてから再試行してください",
  microLabAuthDataContractInvalid:
    "Micro Lab の現在のユーザーロール契約が無効です。管理者に連絡してください",
  microLabMemberContractInvalid:
    "Micro Lab のメンバーロール契約が無効です。管理者に連絡してください",
  platformIntelligenceAuditTokenUsageInvalid:
    "インテリジェンス監査トークン使用量の項目 {field} が不正です。管理者に連絡してください",
  platformKnowledgeLibraryAuthInvalidAppSession:
    "ナレッジライブラリのセッションが失効しました。再度サインインしてください",
  platformToolsLibraryContractInvalidEnum:
    "ツールライブラリのフィルタ列挙値が不正です。再読み込みして再試行するか、管理者に連絡してください",
  redblueMemberContractInvalid: "RedBlue のメンバーロール契約が無効です。管理者に連絡してください",
  toolsLibraryDownloadFilenameMissing:
    "ツールダウンロードのレスポンスにファイル名がありません。管理者に連絡してください",
} as const;
